export default __webpack_public_path__ + "static/media/awards-player-bottom.0f86b070.png";